import React from 'react'
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Category,
  Legend,
  Tooltip,
  DataLabel,
  AxisModel,
  LineSeries,
  ColumnSeries,
} from '@syncfusion/ej2-react-charts'
import { ChartSeriesData } from '@dataTypes/dashboard.types'

type Data = {
  x: string
  y: number
  color: string
}

type BarChartLineProps = {
  title: string
  isTransposed: boolean
  data: Data[]
  primaryXAxis?: AxisModel
  primaryYAxis?: AxisModel
  onClick?: () => void
  lineData: ChartSeriesData[]
  lineSeriesNames: string[]
}

function BarChartLine({
  title,
  data,
  primaryXAxis,
  primaryYAxis,
  lineData,
}: BarChartLineProps): React.ReactElement {
  /*NOTE: This supposed to be a Bar Chart and Line Chart combination but syncfusion does not allow it,  
  so for the mean time I will use column chart*/

  const defaultprimaryYAxis: AxisModel = {
    minimum: 2.0,
    maximum: 4.0,
    interval: 0.2,
  }
  const defaultprimaryXAxis: AxisModel = { valueType: 'Category' }

  return (
    <ChartComponent
      id={title}
      primaryXAxis={primaryXAxis ?? defaultprimaryXAxis}
      primaryYAxis={primaryYAxis ?? defaultprimaryYAxis}
      tooltip={{ enable: true }}
      height="250"
      legendSettings={{
        visible: true,
        position: 'Top',
        alignment: 'Center',
        height: '200',
      }}
    >
      <SeriesCollectionDirective>
        <SeriesDirective
          key={title}
          dataSource={lineData}
          tooltipMappingName={'xValue'}
          xName="xValue"
          yName="y"
          type="Line"
          marker={{ visible: false }}
          width={5}
          fill={'#E7E7E7'}
        />
        <SeriesDirective
          key={title}
          type="Column"
          dataSource={data}
          xName="x"
          yName="y"
          pointColorMapping="color"
          legendShape="Rectangle"
        />
      </SeriesCollectionDirective>
      <Inject
        services={[
          ColumnSeries,
          LineSeries,
          Legend,
          Tooltip,
          DataLabel,
          Category,
        ]}
      />
    </ChartComponent>
  )
}
export default BarChartLine
